<div class="alert alert-success alertMessageStyles80" role="alert" *ngIf="displaySuccessAlert">
  <h5 class="H5Normal" style="display:inline">{{this.successText}}</h5>
  <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideSuccessAlert()">X</h5>
</div>

<div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayFailureAlert">
  <h5 class="H5Normal" style="display:inline" [innerHTML]="this.failureText"></h5>
  <h5 class="H5Normal" style="cursor:pointer;display:inline;float:right;" (click)="HideFailureAlert()">X</h5>
</div>

<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
  <!-- Credits Modal -->
  <div id="creditsModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content" class="creditsModalInner">
      <h2 class="DIN2014Regular blackText" style="font-size:28px">Credits</h2>
      <div style="height:30vh; overflow-y:auto; overflow-x: hidden">
        <div class="container-fluid mt-4 d-none d-md-inline">
          <div class="row">
            <div class="col-md-3">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortCreditsGrid('SOPNumber')">
                Credit #
              </h6>
            </div>
            <div class="col-md-5">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortCreditsGrid('DocDescription')">
                Description
              </h6>
            </div>
            <div class="col-md-2">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortCreditsGrid('DocumentDate')">
                Date
              </h6>
            </div>
            <div class="col-md-2">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortCreditsGrid('CreditAmount')">
                Amount
              </h6>
            </div>
          </div>
        </div>

        <div class="container-fluid" style="max-height: 52vh;">
          <div *ngFor="let credit of this.credits">
            <!-- desktop view -->
            <div class="row"
              *ngIf="!(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
              <div class="col-md-3">
                <a role="button" (click)="OpenPdfDoc('creditmemo',credit.SOPNumber)">
                  <h6 class="H6Normal" style="color:blue;cursor:pointer">{{credit.SOPNumber}}</h6>
                </a>
              </div>
              <div class="col-md-5">
                <h6 class="H6Normal">{{credit.DocDescription}}</h6>
              </div>
              <div class="col-md-2">
                <h6 class="H6Normal">{{credit.DocumentDate}}</h6>
              </div>
              <div class="col-md-2">
                <h6 class="H6Normal">{{credit.CreditAmount | currency}}</h6>
              </div>
            </div>
            <!-- mobile view  -->
            <div class="row" style="border-bottom: solid 1px lightgray; padding:10px"
              *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
              <!-- <div class="row"> -->
              <div class="col-3">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">
                  Credit#
                </h6>
              </div>
              <div class="col-8">
                <a role="button" (click)="OpenPdfDoc('creditmemo',credit.SOPNumber)">
                  <h6 class="H6Normal" style="color:blue;cursor:pointer">{{credit.SOPNumber}}</h6>
                </a>
              </div>
              <!-- </div> -->
              <div class="col-3">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">
                  Desc
                </h6>
              </div>
              <div class="col-8">
                <h6 class="H6Normal">{{credit.DocDescription}}</h6>
              </div>
              <div class="col-3">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">
                  Date
                </h6>
              </div>
              <div class="col-8">
                <h6 class="H6Normal">{{credit.DocumentDate}}</h6>
              </div>
              <div class="col-3">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">
                  Amount
                </h6>
              </div>
              <div class="col-8">
                <h6 class="H6Normal">{{credit.CreditAmount | currency}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h6 style="text-align: right;margin-top:40px; margin-right:20px"><a class="DIN2014 greenBackground whiteText"
          style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
          (click)="CloseCreditsModal()">Close</a></h6>
    </div>
  </div>
  <!-- End Credits Modal -->
  <div class="row">
    <!-- left side panel  -->
    <div class="col-lg-2 pr-0" style="padding-right:0">
      <div class="row w-100 pt-3"><img class="myHarrellsTopLogo" src={{myHarrellsLogoPath}} alt="myHarrellsLogo"></div>
      <!-- customer drodpdown -->
      <div class="col-md-auto mt-2" style="text-align: center;">
        <input class="H6Normal InputElementCustom addressInputs" type="text" placeholder="--Select Customer--"
          autocomplete="off" [(ngModel)]="this.myHarrellsService.customerSelected" (focus)="CustomersFocus()"
          (keyup)="FilterCustomers()">
        <UL class="no-bullets" *ngIf="this.showCustomersList"
          style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:5px">
          <h6 style="text-align: right;cursor: pointer; color:blue" (click)="CloseCustomerDD()">close
          </h6>
          <li class="H6Normal" *ngFor="let customer of this.customersListFiltered" (click)="CustomerSelected(customer)">
            {{customer.Name}}
        </UL>
      </div>
      <!-- addresses dropdown -->
      <div class="col-md-auto mt-2" style="text-align: center;">
        <input class="H6Normal InputElementCustom addressInputs" type="text" placeholder="--Select Address--"
          autocomplete="off" [(ngModel)]="this.myHarrellsService.addressSelected" (focus)="AddressesFocus()"
          (keyup)="FilterAddresses()">
        <UL class="no-bullets" *ngIf="this.showAddressList"
          style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:5px">
          <h6 style="text-align: right;cursor: pointer; color:blue" (click)="CloseAddressDD()">close</h6>
          <li class="H6Normal" *ngFor="let address of this.myHarrellsService.addressesListFiltered"
            (click)="AddressSelected(address)">
            {{address.Address1}}
        </UL>
      </div>
      <!-- type icons show on non mobile only -->
      <div class="d-none d-md-block">
        <div class="row w-100 pt-3 mt-2"
          *ngIf="this.myHarrellsService.loggedInMyHarrellsUser &&  this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1"
          style="cursor:pointer;margin-left:2px; border: solid 1px lightgray" (click)="MenuChanged('Invoices')">
          <img src="{{imagefilePath + '/InvoicesIcon.png'}}" style="cursor:pointer; width:8vh; margin:auto"
            alt="images">
          <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">Invoices</h5>
        </div>




        <div class="row w-100 pt-3" style="cursor:pointer;margin-left:2px; border: solid 1px lightgray"
          (click)="MenuChanged('Open Orders')">
          <img src="{{imagefilePath + '/OpenOrders.png'}}" style="cursor:pointer; width:8vh; margin:auto"
            alt="Open Orders">
          <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">Open Orders</h5>
        </div>
        <!-- hide the My Products menu item for now -->
        <div class="row w-100 pt-3" style="cursor:pointer;margin-left:2px; border: solid 1px lightgray"
          (click)="MenuChanged('My Products')">
          <img src="{{imagefilePath + '/MyProducts.png'}}" style="cursor:pointer; width:8vh; margin:auto"
            alt="MyProducts">
          <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">My Products</h5>
        </div>
        <div class="row w-100 pt-3" style="cursor:pointer;margin-left:2px; border: solid 1px lightgray"
          *ngIf="myHarrellsService.displayOnlineOrderingLink" (click)="MenuChanged('Online Orders')">
          <img src="{{imagefilePath + '/OnlineOrdering.png'}}" style="cursor:pointer; width:8vh; margin:auto"
            alt="Online Orders">
          <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">Online Orders</h5>
        </div>
        <div class="row w-100 pt-3 mb-5" style="cursor:pointer;margin-left:2px; border: solid 1px lightgray"
          (click)="MenuChanged('Bill & Hold Items')">
          <img src="{{imagefilePath + '/BillAndHoldIcon.png'}}" style="cursor:pointer; width:8vh; margin:auto"
            alt="Bill and Hold Items">
          <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">Bill & Hold</h5>
        </div>
      </div>
    </div>
    <!-- <div class="row w-100 pt-3" style="cursor:pointer;margin-left:2px; border: solid 1px lightgray"
            (click)="MenuChanged('How To')">
            <img src="{{imagefilePath + '/HowToIcon.png'}}" style="cursor:pointer; width:8vh; margin:auto" alt="How To">
            <h5 class="DIN2014Regular blackText" style="font-size:18px; text-align: center;">How To</h5>
          </div> -->
    <!-- main display panel in center -->
    <!-- <div class="col-lg-10" style="padding-right:0; padding-bottom:500px"> -->
    <div class="col-lg-10" style="padding-right:0">
      <div class="row w-100 pt-3 blueBackground ml-0"
        *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
        <h5 class=" col-4 DIN2014Regular whiteText d-inline" style="font-size:18pt; text-align: left;">
          {{headerBarTitle}}</h5>
        <h5 class=" col-4 DIN2014Regular whiteText d-inline" style="font-size:18pt; text-align: center;">
          {{this.myHarrellsService.loggedInMyHarrellsUser.Email}}</h5>
        <h5 class=" col-4 DIN2014Regular whiteText d-inline" style="cursor:pointer; font-size:18pt; text-align: right;"
          (click)="Logout()">Logout</h5>
      </div>
      <div class="row w-100 pt-3 blueBackground ml-0 mt-2"
        *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'">
        <!-- MYHARRELLS hamburger menu start -->
        <div class="col-3" style="margin-top:-5px"
          *ngIf="(this.myHarrellsService.loggedInMyHarrellsUser && (this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'))">
          <div (click)="DisplayMyHarrellsMenu()">
            <h1 class="myHarrellsMenuBarDetail"></h1>
            <h1 class="myHarrellsMenuBarDetail"></h1>
            <h1 class="myHarrellsMenuBarDetail"></h1>
          </div>
          <div *ngIf="displayMyHarrellsMobileMenu" class="blueBackground whiteText"
            style="position:fixed; top:0; left:0; height:100%; width:100%; z-index: 1000;">
            <div class="row">
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="cursor:pointer;text-align: right; font-size: 36px;color: white;width:95vw;margin-top: 15px;"
                  (click)="CloseMyHarrellsMobileMenu()">X</h3>
              </div>
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="text-align: left; font-size: 36px;color: white;margin-left: 20px;margin-top: 15px;"
                  (click)="MenuChanged('Invoices');this.CloseMyHarrellsMobileMenu()">
                  Invoices</h3>
              </div>
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="text-align: left; font-size: 36px;color: white;margin-left: 20px;margin-top: 15px;"
                  (click)="MenuChanged('Open Orders');CloseMyHarrellsMobileMenu()">
                  Open Orders</h3>
              </div>
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="text-align: left; font-size: 36px;color: white;margin-left: 20px;margin-top: 15px;"
                  (click)="MenuChanged('My Products');CloseMyHarrellsMobileMenu()">
                  My Products</h3>
              </div>
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="text-align: left; font-size: 36px;color: white;margin-left: 20px;margin-top: 15px;"
                  (click)="MenuChanged('Online Orders');CloseMyHarrellsMobileMenu()">
                  Online Orders</h3>
              </div>
              <div class="col-12">
                <h3 class="Din2014Regular whiteText"
                  style="text-align: left; font-size: 36px;color: white;margin-left: 20px;margin-top: 15px;"
                  (click)="MenuChanged('Bill & Hold Items');CloseMyHarrellsMobileMenu()">
                  Bill & Hold Items</h3>
              </div>
            </div>
          </div>
        </div>
        <h5 class=" col-6 DIN2014Regular whiteText d-inline" style="font-size:18pt; text-align: center;">
          {{headerBarTitle}}</h5>
        <img src="{{imagefilePath + '/filterIcon.png'}}"
          style="cursor:pointer; width:60px; height:25px; position:absolute; right:5px" alt="filter icon"
          (click)="ToggleFilter()">
        <h5 class=" col-3 DIN2014Regular blueText inline"
          style="position:absolute; right:5px; top:20px;cursor:pointer; font-size:16pt; text-align: right;"
          (click)="Logout()">Logout</h5>
      </div>

      <!-- Invoices main section -->
      <div *ngIf="headerBarTitle == 'Invoices'" class="row w-100 pt-3">
        <div class="row"
          [ngClass]="(this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm') 
        || ((this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm') && showFilterObjects ) ? '': 'hideFilterObjectsPanel' ">
          <!-- Invoice # drodpdown -->
          <div class="col-md-auto mt-2 p-0">
            <input class="filterInputs" type="text" placeholder="Invoice #" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesInvoiceNumberSelected" (focus)="InvoiceNumberFocus()"
              (keyup)="FilterInvoiceNumbers()"><span class="xToCancel" (click)="InvoiceNumberSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoiceNumberList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showInvoiceNumberList=false">
                close
              </h6>
              <li *ngFor="let invoice of this.invoiceNumberFiltered" (click)="InvoiceNumberSelected(invoice)">
                <span class="pointer">{{invoice}}</span>
            </UL>
          </div>
          <div class="col-md-auto mt-2 p-0">
            <input class="filterInputs" type="text" placeholder="PO #" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesPOSelected" (focus)="InvoicePOFocus()"
              (keyup)="FilterInvoicePO()"><span class="xToCancel" (click)="InvoicePOSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoicePOList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showInvoicePOList=false">
                close
              </h6>
              <li *ngFor="let po of this.invoicePOFiltered" (click)="InvoicePOSelected(po)">
                <span class="pointer">{{po}}</span>
            </UL>
          </div>
          <!-- Item # drodpdown -->
          <div class="col-md-auto mt-2 p-0" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
            <input class="filterInputs" type="text" placeholder="Item #" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesItemNumberSelected" (focus)="ItemNumberFocus()"
              (keyup)="FilterItemNumbers()"><span class="xToCancel" (click)="ItemNumberSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoicesItemNumbersList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue"
                (click)="this.showInvoicesItemNumbersList=false">
                close
              </h6>
              <li *ngFor="let item of this.invoicesItemNumberFiltered" (click)="ItemNumberSelected(item)">
                <span class="xToCancelLI">{{item}}</span>
            </UL>
          </div>
          <!-- Class drodpdown -->
          <div class="col-md-auto mt-2 p-0" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
            <input class="filterInputs" type="text" placeholder="Class" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesClassSelected" (focus)="ClassFocus()"
              (keyup)="FilterClasses()"><span class="xToCancel" (click)="ClassSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoicesClassList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showInvoicesClassList=false">
                close
              </h6>
              <li *ngFor="let class of this.invoicesClassListFiltered" (click)="ClassSelected(class)">
                <span class="xToCancelLI">{{class}}</span>
            </UL>
          </div>
          <!-- Type drodpdown -->
          <div class="col-md-auto mt-2 p-0" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
            <input class="filterInputs" type="text" placeholder="Type" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesTypeSelected" (focus)="TypeFocus()"
              (keyup)="FilterType()"><span class="xToCancel" (click)="TypeSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoicesTypeList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showInvoicesTypeList=false">
                close
              </h6>
              <li *ngFor="let type of this.invoicesTypeListFiltered" (click)="TypeSelected(type)">
                <span class="xToCancelLI">{{type}}</span>
            </UL>
          </div>
          <!-- Vendor -->
          <div class="col-md-auto mt-2 p-0" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
            <input class="filterInputs" type="text" placeholder="Vendor" autocomplete="off"
              [(ngModel)]="this.myHarrellsService.invoicesVendorSelected" (focus)="VendorFocus()"
              (keyup)="FilterVendor()"><span class="xToCancel" (click)="VendorSelected('')">X</span>
            <UL class="no-bullets" *ngIf="this.showInvoicesVendorList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showInvoicesVendorList=false">
                close
              </h6>
              <li *ngFor="let vendor of this.invoicesVendorListFiltered" (click)="VendorSelected(vendor)">
                <span class="xToCancelLI">{{vendor}}</span>
            </UL>
          </div>
          <!-- from date -->
          <div class="col-md-auto mt-2 p-0 mr-2">
            <input class="invoicesFromDate" type="date" id="invoicesFromDate" placeholder="From Date"
              (focus)="InvoiceFromDateFocus()" (change)="InvoiceFromDateChanged($event)">
          </div>

          <!-- to date -->
          <div class="col-md-auto mt-2 p-0">
            <input class="invoicesToDate" type="date" id="invoicesToDate" placeholder="To Date"
              (focus)="InvoiceToDateFocus()" (change)="InvoiceToDateChanged($event)" max="2030-12-31" min="1000-01-01">
          </div>
        </div>
        <!-- display radio buttons for summary detail and non zero invoices only -->
        <!-- mobile view -->
        <div class="row d-xs-block d-sm-block d-md-none text-center"
          style="border-bottom: solid 1px grey; padding-bottom:15px;margin-left:10px;margin-bottom:10px">
          <div class="d-inline row">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroupMobile" id="summaryViewMobile"
              (change)="ViewInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="summaryViewMobile">
              Summary
            </label>
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroupMobile" id="detailViewMobile"
              checked (change)="ViewInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="detailViewMobile">
              Detail
            </label>
          </div>
          <div class="d-inline row">
            <input class="form-check-input d-inline mt-2" type="radio" name="dollarTypeGroupMobile" id="nonZeroMobile"
              checked (change)="DollaryInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="nonZeroMobile">
              Show non $0 Invoices Only
            </label><br>
            <input class="form-check-input d-inline mt-2" type="radio" name="dollarTypeGroupMobile"
              id="allInvoicesMobile" (change)="DollaryInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="allInvoicesMobile">
              All Invoices
            </label>
          </div>
          <div class="d-inline">
            <h6 (click)="OpenCreditsModal()" style="display:inline-block" *ngIf="this.hasCredits" class="rowHighlight">
              View Credits
            </h6>
          </div>
        </div>
        <!-- desktop  -->
        <div class="row DIN2014Regular d-none d-md-inline">
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroup" id="summaryView"
              (change)="ViewInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="summaryView">
              Summary
            </label>
          </div>
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroup" id="detailView" checked
              (change)="ViewInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="detailView">
              Detail
            </label>
          </div>
          <div class="d-inline">
            <h6 class="d-inline">|</h6>
          </div>
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="dollarTypeGroup" id="nonZero" checked
              (change)="DollaryInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="nonZero">
              Show non $0 Invoices Only
            </label>
          </div>
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="dollarTypeGroup" id="allInvoices"
              (change)="DollaryInvoiceRadioChanged($event)">
            <label class="form-check-label d-inline" for="allInvoices">
              All Invoices
            </label>
          </div>
          <div class="d-inline">
            <h6 class="d-inline">|</h6>
          </div>
          <div class="d-inline">
            <button type="button" (click)="GetInvoiceExcel()" class="btn btn-default invoice-print"><img
                src={{excelFileLogoPath}} style="max-height: 25px !important" />Excel Export</button>
          </div>
          <div class="d-inline">
            <h6 class="d-inline">|</h6>
          </div>
          <div class="d-inline">
            <h6 (click)="OpenCreditsModal()" style="display:inline-block"
              [ngClass]="this.hasCredits ? 'rowHighlight': 'greyText'">View Credits</h6>
          </div>
        </div>
        <!-- invoices grid desktop-->
        <div class="container-fluid mt-4"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
          <div class="row">
            <div class="col-md-1">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Invoice#')">
                Invoice#
              </h6>
            </div>
            <div class="col-md-1">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('PO#')">
                PO#
              </h6>
            </div>
            <div class="col-md-1">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Date')">
                Date
              </h6>
            </div>
            <div class="col-md-5" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('ShipTo')">
                Ship To</h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('NumItems')">#
                of Items</h6>
            </div>
            <div class="col-md-3" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Item')">Item
              </h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Class')">
                Class</h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Type')">Type
              </h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Vendor')">
                Vendor
              </h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Qty')">Qty
              </h6>
            </div>
            <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Price')">
                Price
              </h6>
            </div>
            <div class="col-md-1">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortInvoicesGrid('Total')">
                Total
              </h6>
            </div>
          </div>
        </div>
        <div class="container-fluid" style="max-height: 52vh; overflow-y: auto;"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
          <div>
            <div *ngFor="let invoice of invoicesFiltered">
              <div class="row" (click)="ShowLineItemsOnSummary(invoice.SOPNumber)" style="cursor:pointer">
                <div class="col-md-1">
                  <a role="button" (click)="OpenPdfDoc('Invoice',invoice.SOPNumber)">
                    <h6 class="H6Normal" style="color:blue;cursor:pointer">{{invoice.SOPNumber}}</h6>
                  </a>
                </div>
                <div class="col-md-1">
                  <h6 class="H6Normal">{{invoice.PO}}</h6>
                </div>
                <div class="col-md-1">
                  <h6 class="H6Normal">{{invoice.DocumentDate}}</h6>
                </div>
                <div class="col-md-5" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
                  <h6 class="H6Normal">{{invoice.Address1.trim()}}, {{invoice.City.trim()}}, {{invoice.State}} </h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
                  <h6 class="H6Normal">{{invoice.NumItems}} </h6>
                </div>
                <div class="col-md-3" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.ItemNumber}}</h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.Class}}</h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.Type}}</h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.Vendor}}</h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.Quantity}}</h6>
                </div>
                <div class="col-md-1" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{invoice.UnitPrice | currency}}</h6>
                </div>
                <div class="col-md-1">
                  <h6 class="H6Normal">{{invoice.ExtendedPrice | currency}}</h6>
                </div>
              </div>
              <div>

                <div class="row"
                  *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary' && this.myHarrellsService.invoicesInvoiceNumberSelected == invoice.SOPNumber">
                  <div style="width:90%">
                    <div class="col-md-2" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold;margin-left:30px">Item #</h6>
                    </div>
                    <div class="col-md-4" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">Desc</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">UofM</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">Qty</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">Price</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">Ext Price</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="font-weight:bold">SDS | Label</h6>
                    </div>
                  </div>
                </div>

                <div class="row"
                  *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary' && this.myHarrellsService.invoicesInvoiceNumberSelected == invoice.SOPNumber">
                  <div *ngFor="let invoice of invoicesItems" style="width:90%">
                    <div class="col-md-2" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block;margin-left:30px">{{invoice.ItemNmbr}}</h6>
                    </div>
                    <div class="col-md-4" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block">{{invoice.ItemDesc}}</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block">{{invoice.UofM}}</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block">{{invoice.Quantity}}</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block">{{invoice.UnitPrice | currency}}</h6>
                    </div>
                    <div class="col-md-1" style="display:inline-block">
                      <h6 class="H6Normal" style="display:inline-block">{{invoice.ExtendedPrice | currency}}</h6>
                    </div>
                    <div class="col-md" style="display:inline-block">
                      <div class="row" style="display: inline-block;"> <!-- Label & SDS  -->
                        <div class="col-md-12">
                          <a style="display: inline-block;" role="button" (click)="OpenPdfDoc('sds', invoice.ItemNmbr)"
                            title="Display SDS">
                            <!-- <h6 class="H6Normal" style="color:blue;cursor:pointer;display: inline-block">SDS</h6> -->
                            <img class="pdf-image" src="{{imagefilePath + '/PDFicon.png'}}">
                          </a>
                          <a style="display: inline-block;margin-left:20px" role="button"
                            (click)="OpenPdfDoc('label', invoice.ItemNmbr)" title="Display Label">
                            <img class="pdf-image" src="{{imagefilePath + '/PDFicon.png'}}">
                            <!-- <h6 class="H6Normal" style="color:blue;cursor:pointer; display: inline-block">Label</h6> -->
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row" style="border-bottom: solid 1px grey"
                  *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
                  <div class="col-md-12">
                    <h6 class="H6Normal" style="margin-left:26%">{{invoice.ProductDesc + ' / ' + invoice.UofM}}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- invoices grid mobile view -->
        <div style="height:50vh; overflow:auto"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'">
          <h3 class="DIN2014Regular blackText mt-5 mb-5" style="font-size:18px; text-align: center;"
            *ngIf="this.myHarrellsService.customerSelected == ''">No Customer Selected</h3>
          <div class="row" *ngFor="let invoice of invoicesFiltered" (click)="ShowLineItemsOnSummary(invoice.SOPNumber)">
            <div class="col-4 text-end">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Invoice#</h6>
            </div>
            <div class="col-8 text-start"> <a role="button" (click)="OpenPdfDoc('Invoice',invoice.SOPNumber)">
                <h6 class="H6Normal" style="color:blue;cursor:pointer">{{invoice.SOPNumber}}</h6>
              </a>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">PO#</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{invoice.PO}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Date</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{invoice.DocumentDate}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Ship To</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal">{{invoice.Address1.trim()}}, {{invoice.City.trim()}}, {{invoice.State}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer"># of Items</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary'">
              <h6 class="H6Normal">{{invoice.NumItems}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Item</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.ItemNumber}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Class</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.Class}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Type</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.Type}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Vendor</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.Vendor}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Qty</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.Quantity}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Price</h6>
            </div>
            <div class="col-8 text-start" *ngIf="this.myHarrellsService.invoiceModeSelected == 'Detail'">
              <h6 class="H6Normal">{{invoice.UnitPrice | currency}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal" style="font-weight:bold;cursor: pointer">Total</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{invoice.ExtendedPrice | currency}}</h6>
            </div>
            <!-- expansion row of items for invoice for mobile summary view -->
            <div class="row"
              *ngIf="this.myHarrellsService.invoiceModeSelected == 'Summary' && this.myHarrellsService.invoicesInvoiceNumberSelected == invoice.SOPNumber">
              <div *ngFor="let invoice of invoicesItems" style="margin-left:10px; padding-left:20px">
                <div class="row"> <!-- Label & SDS  -->
                  <div class="col-8" style="display:inline-block; text-align:left">
                    <h6 class="H6Normal" style="display:inline-block;font-weight:bold">Item</h6>
                  </div>
                  <div class="col-2">
                    <h6 class="H6Normal" style="display:inline-block;font-weight:bold">SDS</h6>
                  </div>
                  <div class="col-2">
                    <h6 class="H6Normal" style="display:inline-block;font-weight:bold">Label</h6>
                  </div>
                </div>
                <div class="row"> <!-- Label & SDS  -->
                  <div class="col-8" style="display:inline-block; text-align:left">
                    <h6 class="H6Normal" style="display:inline-block;">{{invoice.ItemNmbr}}</h6>
                  </div>
                  <div class="col-2">
                    <a style="display: inline-block;" role="button" (click)="OpenPdfDoc('sds', invoice.ItemNmbr)"
                      title="Display SDS">
                      <!-- <h6 class="H6Normal" style="color:blue;cursor:pointer;display: inline-block">SDS</h6> -->
                      <img class="pdf-image" src="{{imagefilePath + '/PDFicon.png'}}">
                    </a>
                  </div>
                  <div class="col-2">
                    <a style="display: inline-block;margin-left:20px" role="button"
                      (click)="OpenPdfDoc('label', invoice.ItemNmbr)" title="Display Label">
                      <img class="pdf-image" src="{{imagefilePath + '/PDFicon.png'}}">
                      <!-- <h6 class="H6Normal" style="color:blue;cursor:pointer; display: inline-block">Label</h6> -->
                    </a>
                  </div>
                </div>
                <div class="col-12" style="display:inline-block">
                  <h6 class="H6Normal" style="display:inline-block">{{invoice.ItemDesc}}</h6>
                </div>
                <!-- <div class="col-md-1" style="display:inline-block">
                <h6 class="H6Normal" style="display:inline-block">({{invoice.UofM}})</h6>
              </div> -->
                <div class="col-md-12" style="display:inline-block">
                  <h6 class="H6Normal" style="display:inline-block">{{invoice.Quantity}} &#64; {{invoice.UnitPrice |
                    currency}} = {{invoice.ExtendedPrice | currency}}</h6>
                </div>
              </div>
            </div>
            <!-- expansion row of items for invoice for summary view -->
            <div class="col-12" style="border-bottom: solid 1px grey; margin:10px"></div>
          </div>
        </div>
      </div>

      <!-- Open Orders main section -->
      <div *ngIf="headerBarTitle.toString() == 'Open Orders'" class="DIN2014Regular row w-100 pt-3">
        <div id="openOrdersFilterPanel"
          [ngClass]="(this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm') 
          || ((this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm') && showFilterObjects ) ? '': 'hideFilterObjectsPanel' ">
          <div class="row">
            <!-- Order Number SOP drodpdown -->
            <div class="col-md-auto mt-2 p-0">
              <input class="filterInputsOO" type="text" placeholder="Invoice #" autocomplete="off"
                [(ngModel)]="this.myHarrellsService.orderSOPNumberSelected" (focus)="OrdersSopNumberFocus()"
                (keyup)="FilterOrdersSOPNumbers()"><span class="xToCancelOO"
                (click)="OrdersSOPNumberSelected('')">X</span>
              <UL class="no-bullets" *ngIf="this.showOrdersSOPNumberList"
                style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
                <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showOrdersSOPNumberList=false">
                  close
                </h6>
                <li *ngFor="let order of this.ordersSOPNumberFiltered"
                  (click)="OrdersSOPNumberSelected(order.SOPNumber)">
                  <span class="xToCancelLI">{{order.SOPNumber}}</span>
              </UL>
            </div>
            <!-- Item # drodpdown -->
            <div class="col-md-auto mt-2 p-0" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <input class="filterInputsOO" type="text" placeholder="Item #" autocomplete="off"
                [(ngModel)]="this.myHarrellsService.ordersItemNumberSelected" (focus)="OrdersItemNumberFocus()"
                (keyup)="FilterOrdersItemNumbers()"><span class="xToCancelOO"
                (click)="OrdersItemNumberSelected('')">X</span>
              <UL class="no-bullets" *ngIf="this.showOrdersItemNumberList"
                style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
                <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showOrdersItemNumberList=false">
                  close
                </h6>
                <li *ngFor="let item of this.ordersItemNumberFiltered"
                  (click)="OrdersItemNumberSelected(item.ItemNumber)">
                  <span class="xToCancelLI">{{item.ItemNumber}}</span>
              </UL>
            </div>
            <!-- Class drodpdown -->
            <div class="col-md-auto mt-2 p-0" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <input class="filterInputsOO" type="text" placeholder="Class" autocomplete="off"
                [(ngModel)]="this.myHarrellsService.ordersClassSelected" (focus)="OrdersClassesFocus()"
                (keyup)="FilterOrdersClasses()"><span class="xToCancelOO" (click)="OrdersClassSelected('')">X</span>
              <UL class="no-bullets" *ngIf="this.showOrdersClassesList"
                style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
                <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showOrdersClassesList=false">
                  close
                </h6>
                <li *ngFor="let class of this.ordersClassesFiltered" (click)="OrdersClassSelected(class.Class)">
                  <span class="xToCancelLI">{{class.Class}}</span>
              </UL>
            </div>
            <!-- Type drodpdown -->
            <div class="col-md-auto mt-2 p-0" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <input class="filterInputsOO" type="text" placeholder="Type" autocomplete="off"
                [(ngModel)]="this.myHarrellsService.ordersTypeSelected" (focus)="OrdersTypesFocus()"
                (keyup)="FilterOrdersTypes()"><span class="xToCancelOO" (click)="OrdersTypeSelected('')">X</span>
              <UL class="no-bullets" *ngIf="this.showOrdersTypesList"
                style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
                <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showOrdersTypesList=false">
                  close
                </h6>
                <li *ngFor="let type of this.ordersTypesFiltered" (click)="OrdersTypeSelected(type.Type)">
                  <span class="xToCancelLI">{{type.Type}}</span>
              </UL>
            </div>
            <!-- Vendor -->
            <div class="col-md-auto mt-2 p-0" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <input class="filterInputsOO" type="text" placeholder="Vendor" autocomplete="off"
                [(ngModel)]="this.myHarrellsService.ordersVendorSelected" (focus)="OrdersVendorsFocus()"
                (keyup)="FilterOrdersVendors()"><span class="xToCancelOO" (click)="OrdersVendorSelected('')">X</span>
              <UL class="no-bullets" *ngIf="this.showOrdersVendorsList"
                style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
                <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showOrdersVendorsList=false">
                  close
                </h6>
                <li *ngFor="let vendor of this.ordersVendorsFiltered" (click)="OrdersVendorSelected(vendor.Vendor)">
                  <span class="xToCancelLI">{{vendor.Vendor}}</span>
              </UL>
            </div>
          </div>
        </div>

        <!-- mobile view Radio button group-->
        <div class="row d-xs-block d-sm-block d-md-none text-center"
          style="border-bottom: solid 1px grey; padding-bottom:15px;margin-left:10px">
          <div class="d-inline row">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroupMobile" id="summaryViewMobile"
              (change)="ViewOrderRadioChanged($event)">
            <label class="form-check-label d-inline" for="summaryViewMobile">
              Summary
            </label>
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroupMobile" id="detailViewMobile"
              checked (change)="ViewOrderRadioChanged($event)">
            <label class="form-check-label d-inline" for="detailViewMobile">
              Detail
            </label>
          </div>
          <!-- Regular/BH Orders radio buttons -->
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="regularBHGroupMobile"
              id="regularOrdersMobile" checked (change)="RegularBHRadioChanged($event)">
            <label class="form-check-label d-inline" for="regularOrdersMobile">
              Regular Orders
            </label>
            <input class="form-check-input d-inline mt-2" type="radio" name="regularBHGroupMobile" id="bhOrdersMobile"
              (change)="RegularBHRadioChanged($event)">
            <label class="form-check-label d-inline" for="bhOrdersMobile">
              Bill & Hold Orders
            </label>
          </div>
        </div>
        <!-- desktop iew Radio button group-->
        <div class="row d-none d-md-inline">
          <!-- Summary/detail radio buttons -->
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroup" id="summaryView"
              (change)="ViewOrderRadioChanged($event)">
            <label class="form-check-label d-inline" for="summaryView">
              Summary
            </label>
          </div>
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="viewTypeGroup" id="detailView" checked
              (change)="ViewOrderRadioChanged($event)">
            <label class="form-check-label d-inline" for="detailView">
              Detail
            </label>
          </div>
          <div class="d-inline">
            <h6 class="d-inline">|</h6>
          </div>
          <!-- Regular/BH Orders radio buttons -->
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="regularBHGroup" id="regularOrders" checked
              (change)="RegularBHRadioChanged($event)">
            <label class="form-check-label d-inline" for="regularOrders">
              Regular Orders
            </label>
          </div>
          <div class="d-inline">
            <input class="form-check-input d-inline mt-2" type="radio" name="regularBHGroup" id="bhOrders"
              (change)="RegularBHRadioChanged($event)">
            <label class="form-check-label d-inline" for="bhOrders">
              Bill & Hold Orders
            </label>
          </div>
          <div class="d-inline">
            <h6 class="d-inline">|</h6>
          </div>
          <div class="d-inline">
            <button type="button" (click)="GetOrdersExcel()" class="btn btn-default invoice-print"><img
                src={{excelFileLogoPath}} style="max-height: 25px !important" />Excel Export</button>
          </div>
        </div>

        <!-- Open Orders grid Desktop-->
        <div
          *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
          <div class="container-fluid mt-4">
            <div class="row">
              <div class="col-md-2">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Order#')">
                  Order#
                </h6>
              </div>
              <div class="col-md-1">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Date')">
                  Date
                </h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Status')">
                  Status</h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Item')">
                  Item</h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Class')">
                  Class</h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Type')">
                  Type
                </h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Vendor')">
                  Vendor</h6>
              </div>
              <div class="col-md-1">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('ReqShip')">
                  Req Ship
                </h6>
              </div>

              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Qty')">
                  Qty
                </h6>
              </div>
              <div class="col-md-3">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('ShipTo')">
                  Ship To
                </h6>
              </div>
              <div class="col-md-2" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('CityState')">
                  City, State</h6>
              </div>
              <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                <h6 class="H6Normal"
                  *ngIf="this.myHarrellsService.loggedInMyHarrellsUser &&  this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1"
                  style="font-weight:bold;cursor: pointer" (click)="SortOpenOrdersGrid('Total')">
                  Total</h6>
              </div>
            </div>
          </div>

          <div class="container-fluid" style="max-height: 52vh; overflow-y: auto" id="openOrdersGrid">
            <div *ngFor="let order of openOrdersFiltered">
              <div class="row">
                <div class="col-md-2">
                  <h6 class="H6Normal">{{order.SOPNumber}}</h6>
                </div>
                <div class="col-md-1">
                  <h6 class="H6Normal">{{order.DocumentDate}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                  <h6 class="H6Normal">{{order.Status}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{order.ItemNumber}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{order.Class}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{order.Type}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{order.Vendor}}</h6>
                </div>
                <div class="col-md-1">
                  <h6 class="H6Normal">{{order.RequestedShipDate}}</h6>
                </div>

                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <h6 class="H6Normal">{{order.Quantity}}</h6>
                </div>
                <div class="col-md-3">
                  <h6 class="H6Normal">{{order.ShipToAddress}}</h6>
                </div>
                <div class="col-md-2" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                  <h6 class="H6Normal">{{order.CityState}}</h6>
                </div>
                <div class="col-md-1" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
                  <h6 class="H6Normal"
                    *ngIf="this.myHarrellsService.loggedInMyHarrellsUser &&  this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1">
                    {{order.ExtendedPrice | currency}}</h6>
                </div>
              </div>
              <div>
                <div class="row" style="border-bottom: solid 1px grey"
                  *ngIf="this.myHarrellsService.openOrdersModeSelected == 'Detail'">
                  <div class="col-md-12">
                    <h6 class="H6Normal" style="margin-left:26%">{{order.ProductDesc + ' / ' + order.UofM}}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Open Orders grid mobile view -->
        <div style="height:50vh; overflow:auto"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'">
          <h3 class="DIN2014Regular blackText mt-5 mb-5" style="font-size:18px; text-align: center;"
            *ngIf="this.myHarrellsService.customerSelected == ''">No Customer Selected</h3>
          <div class="row" *ngFor="let order of openOrdersFiltered">
            <div class="col-4 text-end">
              <h6 class="H6Normal">Order#</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{order.SOPNumber}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal">Date</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{order.DocumentDate}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">Status</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">{{order.Status}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">Item</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">{{order.ItemNmbr}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">Class</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">{{order.Class}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">Type</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">{{order.Type}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">Vendor</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">{{order.Vendor}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal">Req Ship</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{order.RequestedShipDate}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">Qty</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
              <h6 class="H6Normal">{{order.Quantity}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal">Ship To</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{order.ShipToAddress}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">City, State</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">{{order.CityState}}</h6>
            </div>
            <div class="col-4 text-end" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">Total</h6>
            </div>
            <div class="col-8 text-start" *ngIf="myHarrellsService.openOrdersModeSelected == 'Summary'">
              <h6 class="H6Normal">{{order.ExtendedPrice | currency}}</h6>
            </div>
            <div style="border-bottom: 1px solid grey">
              <div class="col-12 text-center" *ngIf="myHarrellsService.openOrdersModeSelected == 'Detail'">
                <h6 class="H6Normal">{{order.ProductDesc + ' / ' + order.UofM}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- My Products main section -->
      <div *ngIf="headerBarTitle.toString() == 'My Products'" class="DIN2014Regular row w-100 pt-3">
        <!-- filters -->
        <div class="row" id="myProductsFilterPanel"
          [ngClass]="(this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm') 
          || ((this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm') && showFilterObjects ) ? '': 'hideFilterObjectsPanel' ">

          <!-- Vendor -->
          <div class="col-md-auto mt-2 p-0">
            <input class="filterInputs" type="text" placeholder="Vendor" autocomplete="off"
              [(ngModel)]="this.myProductsVendorSelected" (focus)="VendorFocusMyProducts()"
              (keyup)="FilterVendorMyProducts()"><span class="xToCancel" (click)="VendorSelectedMyProducts('')">X</span>
            <UL class="no-bullets" *ngIf="this.showMyProductsVendorList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showMyProductsVendorList=false">
                close
              </h6>
              <li *ngFor="let vendor of this.myProductsVendorListFiltered" (click)="VendorSelectedMyProducts(vendor)">
                <span class="xToCancelLI">{{vendor}}</span>
            </UL>
          </div>
          <!-- Class drodpdown -->
          <div class="col-md-auto mt-2 p-0">
            <input class="filterInputs" type="text" placeholder="Class" autocomplete="off"
              [(ngModel)]="this.myProductsClassSelected" (focus)="ClassFocusMyProducts()"
              (keyup)="FilterClassesMyProducts()"><span class="xToCancel" (click)="ClassSelectedMyProducts('')">X</span>
            <UL class="no-bullets" *ngIf="this.showMyProductsClassList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showMyProductsClassList=false">
                close
              </h6>
              <li *ngFor="let class of this.myProductsClassListFiltered" (click)="ClassSelectedMyProducts(class)">
                <span class="xToCancelLI">{{class}}</span>
            </UL>
          </div>
          <!-- Type drodpdown -->
          <div class="col-md-auto mt-2 p-0">
            <input class="filterInputs" type="text" placeholder="Type" autocomplete="off"
              [(ngModel)]="this.myProductsTypeSelected" (focus)="TypeFocusMyProducts()"
              (keyup)="FilterTypeMyProducts()"><span class="xToCancel" (click)="TypeSelectedMyProducts('')">X</span>
            <UL class="no-bullets" *ngIf="this.showMyProductsTypeList"
              style="position:absolute;background-color:white;height:300px; width:300px; z-index: 2;overflow:auto; border:solid 1px grey; margin-left:15px">
              <h6 style="text-align: right;cursor: pointer; color:blue" (click)="this.showMyProductsTypeList=false">
                close
              </h6>
              <li *ngFor="let type of this.myProductsTypeListFiltered" (click)="TypeSelectedMyProducts(type)">
                <span class="xToCancelLI">{{type}}</span>
            </UL>
          </div>
        </div>

        <!-- my products grid desktop view  -->
        <div class="container-fluid mt-4"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
          <div class="row">
            <div class="col-md-9">
              <div class="col-md-2" style="display:inline-block">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer" (click)="SortMyProductsGrid('Item')">
                  Item
                </h6>
              </div>
              <div class="col-md-7" style="display:inline-block">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer; margin-left:-5px"
                  (click)="SortMyProductsGrid('Description')">
                  Description
                </h6>
              </div>
              <div class="col-md-3" style="display:inline-block">
                <h6 class="H6Normal" style="font-weight:bold;cursor: pointer; margin-left:-20px"
                  (click)="SortMyProductsGrid('UofM')">
                  U of M</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9" style="height:55vh; overflow:auto; padding-right:20px">
              <div *ngFor="let product of myProductsFiltered" (click)="MyProductsRowClicked(product)"
                style="cursor:pointer; border-bottom: 1px solid grey">
                <div class="col-md-2" style="display:inline-block">
                  <h6 class="H6Normal"
                    [ngClass]="this.selectedMyProductRowId==product.ItemNumber ? 'rowHighlight': '' ">
                    {{product.ItemNumber}}</h6>
                </div>
                <div class="col-md-7" style="display:inline-block">
                  <h6 class="H6Normal"
                    [ngClass]="this.selectedMyProductRowId==product.ItemNumber ? 'rowHighlight': '' ">
                    {{product.ProductDesc}}</h6>
                </div>

                <div class="col-md-3" style="display:inline-block">
                  <h6 class="H6Normal"
                    [ngClass]="this.selectedMyProductRowId==product.ItemNumber ? 'rowHighlight': '' ">
                    {{product.UofM}}</h6>
                </div>
              </div>

            </div>
            <div class="col-md-3" style="margin-top:-30px">
              <div class="row" style="display: flex; align-items: center; justify-content: center;">
                <button class="DIN2014Bold blueBackground whiteText" [disabled]="this.selectedMyProductRowId == ''"
                  [ngClass]="this.selectedMyProductRowId == '' ? 'greyDisabled': 'blueBackground'"
                  style="width:90px; border:none; font-size:20px; line-height: 2; text-decoration: none !important"
                  (click)="dotComService.product.WebName = this.selectedProduct.ItemNumber; this.dotComService.DisplaySDSPDF(this.selectedProduct.ItemNumber)">SDS</button>
                <button class="DIN2014Bold blueBackground whiteText" [disabled]="this.selectedMyProductRowId == ''"
                  [ngClass]="this.selectedMyProductRowId == '' ? 'greyDisabled': 'blueBackground'"
                  style="width:90px; border:none; margin-left:10px; font-size:20px; line-height: 2; text-decoration: none !important"
                  (click)="dotComService.product.WebName = this.selectedProduct.ItemNumber; this.dotComService.DisplayLabelPDF(this.selectedProduct.ItemNumber)">LABEL</button>
                <button class="DIN2014Bold blueBackground whiteText" [disabled]="this.selectedMyProductRowId == ''"
                  [ngClass]="this.selectedMyProductRowId == '' ? 'greyDisabled': 'blueBackground'"
                  style="width:90px; border:none; margin-left:10px; font-size:20px; line-height: 2; text-decoration: none !important"
                  (click)="OpenCalculator()">CALC</button>
              </div>
              <div class="row w-100 pt-3 lightCremeBackground ml-0">
                <h5 class="DIN2014Regular blueText d-inline" style="font-size:18pt; text-align: left;">
                  Details</h5>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <h6 class="H6Normal" style="font-weight:bold">Package Size:</h6>
                </div>
                <div class="col-md-8">
                  <h6 class="H6Normal">{{this.selectedProduct.PackageInfo}}</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <h6 class="H6Normal" style="font-weight:bold">Class:</h6>
                </div>
                <div class="col-md-8">
                  <h6 class="H6Normal">{{this.selectedProduct.Class}}</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <h6 class="H6Normal" style="font-weight:bold">Type:</h6>
                </div>
                <div class="col-md-8">
                  <h6 class="H6Normal">{{this.selectedProduct.Type}}</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <h6 class="H6Normal" style="font-weight:bold">Vendor:</h6>
                </div>
                <div class="col-md-8">
                  <h6 class="H6Normal">{{this.selectedProduct.Vendor}}</h6>
                </div>
              </div>
              <div class="row w-100 pt-3 lightCremeBackground ml-0 mt-3">
                <h5 class="DIN2014Regular blueText d-inline" style="font-size:18pt; text-align: left;">
                  Active Ingredients</h5>
              </div>
              <div *ngIf="selectedProductsActiveIngredients.length>0">
                <div class="row">
                  <div class="col-md-8">
                    <h6 class="H6Normal" style="font-weight:bold">Ingredient</h6>
                  </div>
                  <div class="col-md-4">
                    <h6 class="H6Normal" style="font-weight:bold">% AI</h6>
                  </div>
                </div>
                <div class="row" *ngFor="let ai of selectedProductsActiveIngredients">
                  <div class="col-md-8">
                    <h6 class="H6Normal">{{ai.Name}}</h6>
                  </div>
                  <div class="col-md-4">
                    <h6 class="H6Normal">{{ai.Percentage}}</h6>
                  </div>
                </div>
              </div>
              <div *ngIf="selectedProductsActiveIngredients.length==0">
                <div class="row">
                  <div class="col-md-12">
                    <h6 class="H6Normal"></h6>
                  </div>
                </div>
              </div>
              <div class="row w-100 pt-3 lightCremeBackground ml-0 mt-3">
                <h5 class="DIN2014Regular blueText d-inline" style="font-size:18pt; text-align: left;">
                  Pests</h5>
              </div>
              <div class="row" *ngIf="this.selectedProduct.PestName != ''">
                <div class="col-12">
                  <h6 class="H6Normal" style="padding-right:20px">{{this.selectedProduct.PestName}}</h6>
                </div>
              </div>
              <div class="row" *ngIf="this.selectedProduct.PestName == ''">
                <div class="col-12">
                  <h6 class="H6Normal"></h6>
                </div>
              </div>
              <div class="row w-100 pt-3 lightCremeBackground ml-0 mt-3">
                <h5 class="DIN2014Regular blueText d-inline" style="font-size:18pt; text-align: left;">
                  Registered States</h5>
              </div>
              <div class="row">
                <div class="col-12">
                  <h6 class="H6Normal" style="padding-right:20px">{{this.selectedProduct.RegisteredStates}}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Open Orders grid mobile view -->
        <div style="height:50vh; overflow:auto"
          *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'">
          <h3 class="DIN2014Regular blackText mt-5 mb-5" style="font-size:18px; text-align: center;"
            *ngIf="this.myHarrellsService.customerSelected == ''">No Customer Selected</h3>
          <div class="row" *ngFor="let product of myProductsFiltered" (click)="MyProductsRowClicked(product)"
            style="border-bottom:1px solid grey; padding-right:10px">
            <div class="col-4 text-end">
              <h6 class="H6Normal">Item</h6>
            </div>
            <div class="col-8 text-start">
              <div class="row">
                <div class="col-6">
                  <h6 class="H6Normal">{{product.ItemNumber}}</h6>
                </div>
                <div class="col-2">
                  <h6 class="H6Normal" (click)="OpenPdfDoc('sds', product.ItemNumber)"
                    style="color: blue;display: inline-block;font-size: 16px;">SDS</h6>
                </div>
                <div class="col-2">
                  <h6 class="H6Normal" (click)="OpenPdfDoc('label', product.ItemNumber)"
                    style="color: blue;display: inline-block;font-size: 16px; margin-left:-5px">Label</h6>
                </div>
                <div class="col-2">
                  <h6 class="H6Normal" (click)="OpenCalculator()"
                    style="color: blue;display: inline-block;font-size: 16px;">Calc</h6>
                </div>
              </div>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal">Description</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{product.ProductDesc}}</h6>
            </div>
            <div class="col-4 text-end">
              <h6 class="H6Normal">U of M</h6>
            </div>
            <div class="col-8 text-start">
              <h6 class="H6Normal">{{product.UofM}}</h6>
            </div>
            <!-- expansion row of details for my products in mobile view -->
            <div class="row" *ngIf="this.selectedMyProductRowId == product.ItemNumber">
              <div style="margin-left:10px; padding-left:20px">
                <div class="row col-12" style="text-align:center">
                  <h6 class="H6Normal" style="font-weight:bold; margin-left:15px">Details</h6>
                </div>
                <div class="row">
                  <div class="col-4 text-end">
                    <h6 class="H6Normal" style="display:inline-block">Package Size</h6>
                  </div>
                  <div class="col-8 text-start">
                    <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.PackageInfo}}</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 text-end">
                    <h6 class="H6Normal" style="display:inline-block">Class</h6>
                  </div>
                  <div class="col-8 text-start">
                    <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.Class}}</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 text-end">
                    <h6 class="H6Normal" style="display:inline-block">Type</h6>
                  </div>
                  <div class="col-8 text-start">
                    <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.Type}}</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 text-end">
                    <h6 class="H6Normal" style="display:inline-block">Vendor</h6>
                  </div>
                  <div class="col-8 text-start">
                    <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.Vendor}}</h6>
                  </div>
                </div>
                <div class="row col-12 mt-2" style="text-align:center">
                  <h6 class="H6Normal" style="font-weight:bold; margin-left:15px">Active Ingredients</h6>
                </div>
                <div *ngIf="selectedProductsActiveIngredients.length==0" style="min-height:20px">
                </div>
                <div *ngIf="selectedProductsActiveIngredients.length>0">
                  <div class="row">
                    <div class="col-8">
                      <h6 class="H6Normal" style="font-weight:bold">Ingredient</h6>
                    </div>
                    <div class="col-4">
                      <h6 class="H6Normal" style="font-weight:bold">% AI</h6>
                    </div>
                  </div>
                  <div class="row" *ngFor="let ai of selectedProductsActiveIngredients">
                    <div class="col-8">
                      <h6 class="H6Normal">{{ai.Name}}</h6>
                    </div>
                    <div class="col-4">
                      <h6 class="H6Normal">{{ai.Percentage}}</h6>
                    </div>
                  </div>
                </div>
                <div class="row col-12" style="text-align:center">
                  <h6 class="H6Normal" style="font-weight:bold; margin-left:15px">Pests</h6>
                </div>
                <div class="col-12 text-start">
                  <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.PestName}}</h6>
                </div>
                <div class="row col-12" style="text-align:center">
                  <h6 class="H6Normal" style="font-weight:bold; margin-left:15px">Registered States</h6>
                </div>
                <div class="col-12 text-start">
                  <h6 class="H6Normal" style="display:inline-block">{{this.selectedProduct.RegisteredStates}}</h6>
                </div>
              </div>
            </div>
          </div>
          <!-- expansion row of details for my products in mobile view -->
        </div>
      </div>
    </div>
    <!-- How To main section -->
    <div *ngIf="headerBarTitle.toString() == 'How To'" class="DIN2014Regular row w-100 pt-3">How To</div>
  </div>
  <div class="row lightCremeBackground pt-3 pb-3">
    <div class="col-lg-3"></div>
    <!-- only client (not client basic) users can see the payment portal link -->
    <div class="col-lg-2 myHarrellsLowerIconLinks" *ngIf="this.myHarrellsService.loggedInMyHarrellsUser &&  
      this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('Client') > -1 && 
      this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1">
      <a (click)="GoToEBizPortal()">
        <!-- <div class="col-lg-2 myHarrellsLowerIconLinks"><a href='https://connect.ebizcharge.net/harrellsllc'> -->
        <img style="cursor:pointer; height:40px; vertical-align:bottom" src="{{this.imagefilePath + '/payment.png'}}"
          alt="payment icon">
        <h5 class="DIN2014Regular blackText"
          style="cursor:pointer;display:inline-block;font-size:18px;margin-left:10px">
          PAYMENT PORTAL</h5>
      </a>
    </div>
    <div class="col-lg-2 myHarrellsLowerIconLinks"><a href='/education'><img style="height:40px; vertical-align:bottom"
          src="{{this.imagefilePath + '/Education.png'}}" alt="education icon">
        <h5 class="DIN2014Regular blackText" style="display:inline-block;font-size:18px;margin-left:10px">
          EDUCATION</h5>
      </a></div>
    <div class="col-lg-2 myHarrellsLowerIconLinks"><a href='https://greensight.turfcloud.com/login' target="_blank"><img
          style="height:40px; vertical-align:bottom" src="{{this.imagefilePath + '/turfcloudIcon.png'}}"
          alt="turfcloud icon">
        <h5 class="DIN2014Regular blackText" style="display:inline-block;font-size:18px;margin-left:10px">
          TURFCLOUD</h5>
      </a></div>
    <div class="col-lg-2 myHarrellsLowerIconLinks"><a href='https://spraye.io/' target="_blank"><img style="height:40px"
          src="{{this.imagefilePath + '/spraye.png'}}" alt="spraye icon">
      </a></div>
  </div>
</div>